import stringify from "json-stringify-safe";

import { isString } from "../../utils/types";
import { SentryService } from "../sentry";

const isDebugMode = () => {
  if (typeof window === "undefined") {
    return false;
  }

  if (process.env.GATSBY_ENV === "dev") {
    return true;
  }

  const params = new URLSearchParams(window.location.search);

  return params.get("debug") !== null;
};

export class Logger {
  static log(...args) {
    if (isDebugMode()) {
      console.log(...args);
    }
  }

  static warn(...args) {
    if (isDebugMode()) {
      console.warn(...args);
    }
  }

  static error(message, ...args) {
    if (isDebugMode()) {
      console.error(...args);
    }

    const serializedArgs = args.map((arg) => {
      if (isString(arg) || arg instanceof Error) {
        return arg;
      }

      return stringify(arg);
    });

    SentryService.captureError({ message, context: serializedArgs });
  }
}
